import api from './api';

/**
 * @returns {Promise<{}[]>}
 */
export default async function deleteRubric(rubric) {
    const {
        skill_id,
        rubric_id,
        task_type_id
    } = rubric;
    const { data } = await api.delete(`/skills/${skill_id}/task_type/${task_type_id}/rubrics/${rubric_id}`);
    return data;
}